import { Group, Mesh } from 'three/webgpu'
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js'

/** Giant Charlie of the Sea. Metres, Y-up, +Z bow, waterline origin. */
export async function loadCruiseShipModel(): Promise<Group> {
  const { scene } = await new GLTFLoader().loadAsync('/models/cruise-ship/cruise-ship.glb')
  const vessel = new Group()
  vessel.name = 'cruise-ship-giant-charlie-of-the-sea'
  scene.rotation.y = -Math.PI / 2
  vessel.add(scene)
  vessel.traverse(object => {
    if (!(object as Mesh).isMesh) return
    object.castShadow = true
    object.receiveShadow = true
  })
  return vessel
}
